// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 2363 ? "premiumcarousel.b422bc86" : chunkId) + "--" + {"1755":"e53ef92","2363":"e66bbec","5104":"e36cd17"}[chunkId] + ".css";
};